/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Confirmed accommodation card without prices or date-dependent availability.
 * @export
 * @interface AccommodationCatalogItemDto
 */
export interface AccommodationCatalogItemDto {
    /**
     * 
     * @type {string}
     * @memberof AccommodationCatalogItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AccommodationCatalogItemDto
     */
    propertyId: string;
    /**
     * 
     * @type {string}
     * @memberof AccommodationCatalogItemDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AccommodationCatalogItemDto
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof AccommodationCatalogItemDto
     */
    cityId: string;
    /**
     * 
     * @type {string}
     * @memberof AccommodationCatalogItemDto
     */
    roomTypeId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccommodationCatalogItemDto
     */
    images: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AccommodationCatalogItemDto
     */
    propertyType: AccommodationCatalogItemDtoPropertyTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AccommodationCatalogItemDto
     */
    stars?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AccommodationCatalogItemDto
     */
    rating?: number | null;
}


/**
 * @export
 */
export const AccommodationCatalogItemDtoPropertyTypeEnum = {
    Hotel: 'HOTEL',
    Apartment: 'APARTMENT'
} as const;
export type AccommodationCatalogItemDtoPropertyTypeEnum = typeof AccommodationCatalogItemDtoPropertyTypeEnum[keyof typeof AccommodationCatalogItemDtoPropertyTypeEnum];


/**
 * Check if a given object implements the AccommodationCatalogItemDto interface.
 */
export function instanceOfAccommodationCatalogItemDto(value: object): value is AccommodationCatalogItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('propertyId' in value) || value['propertyId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('cityId' in value) || value['cityId'] === undefined) return false;
    if (!('images' in value) || value['images'] === undefined) return false;
    if (!('propertyType' in value) || value['propertyType'] === undefined) return false;
    return true;
}

export function AccommodationCatalogItemDtoFromJSON(json: any): AccommodationCatalogItemDto {
    return AccommodationCatalogItemDtoFromJSONTyped(json, false);
}

export function AccommodationCatalogItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccommodationCatalogItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'propertyId': json['propertyId'],
        'name': json['name'],
        'address': json['address'],
        'cityId': json['cityId'],
        'roomTypeId': json['roomTypeId'] == null ? undefined : json['roomTypeId'],
        'images': json['images'],
        'propertyType': json['propertyType'],
        'stars': json['stars'] == null ? undefined : json['stars'],
        'rating': json['rating'] == null ? undefined : json['rating'],
    };
}

  export function AccommodationCatalogItemDtoToJSON(json: any): AccommodationCatalogItemDto {
      return AccommodationCatalogItemDtoToJSONTyped(json, false);
  }

  export function AccommodationCatalogItemDtoToJSONTyped(value?: AccommodationCatalogItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'propertyId': value['propertyId'],
        'name': value['name'],
        'address': value['address'],
        'cityId': value['cityId'],
        'roomTypeId': value['roomTypeId'],
        'images': value['images'],
        'propertyType': value['propertyType'],
        'stars': value['stars'],
        'rating': value['rating'],
    };
}

